import { makeAccount } from '@api/models/account.model';
import { makeCustomerProduct } from '../models/customer-product.model';
import { makePaymentOption } from '../models/payment-option.model';

class CustomerApiService {
  constructor(HttpService, SessionService) {
    'ngInject';

    this.HttpService = HttpService;
    this.SessionService = SessionService;
  }

  getProducts() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/products').then(customerProductsPayload => {
      return customerProductsPayload.map(payload => makeCustomerProduct(payload));
    });
  }

  getCustomerProducts() {
    return this.getProducts();
  }

  getMemberProducts() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/products');
  }

  // TODO: We must not query all the products just to get the brokerageSyncId
  getBrokerageSyncId() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/products');
  }

  getPaymentOptions() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/payment-options').then(paymentOptions => {
      return paymentOptions.map(paymentOptionPayload => makePaymentOption(paymentOptionPayload));
    });
  }

  getBalance() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/balance');
  }

  getAccount() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/balance').then(payload => makeAccount(payload));
  }

  getNotifications() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/notifications');
  }

  readNotifications() {
    return this.HttpService.put('/' + this.SessionService.getLocale() + '/customer/read-notifications');
  }

  saveRestoreId(payload) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/customer/restore-id/save', payload);
  }

  updateLanguage(language) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/customer/language/update/' + language);
  }

  getGoogleAuthenticationCode() {
    return this.HttpService.get('/auth/two-factor/qr-code');
  }

  activateGoogleTwoFactor(payload) {
    return this.HttpService.post('/customer/two-factor/activate', payload);
  }
  
  switchTwoFactor() {
    return this.HttpService.post('/customer/two-factor/switch', {});
  }

  setupTransactionPassword(payload) {
    return this.HttpService.post('/customer/transaction-password/setup', payload);
  }

  updateAvatar(payload)  {
    return this.HttpService.post('/' + this.SessionService.getLocale() +  '/customer/avatar/update', payload, 'json', { reportProgress: true, observe: 'events', 'Content-Type': undefined });
  }

  getAvatar(filename) {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/avatar/get/' + filename);
  }
  
  resetGoogleAuthenticationCode() {
    return this.HttpService.post('/'+ this.SessionService.getLocale() +'/reset/google-auth');
  }
}

export default CustomerApiService;



// WEBPACK FOOTER //
// ./client/app/api/services/customer.api.service.js